// @ts-nocheck
import React from "react";
import GeoJSONMap from "../../GeoJSONMap";

// This component renders different views (graph, table, hybrid) of the asset graph dashboard

// based on the selected displayView prop.
const AssetGraphDashboardView = ({
  displayView,
  isMobile,
  renderGraph,
  renderTable,
  disableMapView,
  selectedAsset,
  assetList,
  onAssetClick,
  stacked = false,
}) => {
  // Stacked charts carry a drag grip at their left edge, which sits a little closer to the card edge (12px) than a lone chart's content (16px)
  const graphPadding = stacked ? "py-2 pl-3 pr-4" : "py-2 px-4";
  // Hybrid view combines both graph and map views
  if (displayView === "hybrid") {
    if (disableMapView) {
      return <div className={`${graphPadding} h-full`}>{renderGraph()}</div>;
    }
    const mapAssets = assetList?.length ? assetList : [selectedAsset];

    // Both panes are shares of the container, not fixed pixels — mobile used to floor the graph at 320px and the map at 260px, which overflows any host shorter than their sum.
    const graphAreaStyle = { height: isMobile ? "58%" : "60%", minHeight: 0 };
    const mapAreaStyle = { height: isMobile ? "42%" : "40%", minHeight: 0 };

    const stopMapEvents = (event) => {
      event.stopPropagation();
    };

    return (
      <div className="flex flex-col h-full">
        <div
          className={isMobile ? "px-5 pt-2" : "p-2"}
          style={graphAreaStyle}
          onWheel={stopMapEvents}
          onTouchStart={stopMapEvents}
          onTouchMove={stopMapEvents}
        >
          {renderGraph()}
        </div>
        <div
          className={isMobile ? "px-6 pb-0.5 pt-1" : "p-1"} // adjust padding for mobile for map on mobile view
          style={mapAreaStyle}
        >
          <GeoJSONMap
            assets={mapAssets}
            defaultLat={selectedAsset.lat}
            defaultLng={selectedAsset.lng}
            selectedAsset={selectedAsset}
            boundsPadding={{ mobile: 10, desktop: 20 }}
            onAssetClick={onAssetClick}
            coordinates={{ lat: selectedAsset?.lat, lng: selectedAsset?.lng }}
          />
        </div>
      </div>
    );
  }

  // This view renders graph and table separately
  if (displayView === "graph") {
    const stopMapEvents = (event) => {
      event.stopPropagation();
    };

    return (
      <div
        className={`${graphPadding} h-full`}
        onWheel={stopMapEvents}
        onTouchStart={stopMapEvents}
        onTouchMove={stopMapEvents}
      >
        {renderGraph()}
      </div>
    );
  }

  if (displayView === "table") {
    return <div className="h-full min-h-0 pt-2">{renderTable()}</div>;
  }

  return null;
};

export default AssetGraphDashboardView;
